module.exports = __webpack_public_path__ + "media/yes2.be20f12d.mp3";